//import React from "react";
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';


// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

import TermoServicoForm from "beaktMatriz/views/Cadastros/TermoServicoForm";

import { useGetApi, UsePostApi, UsePutApi,UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function TermoServicoList() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const endPoint = 'termoservicos/';  
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);

    const endPointGet = endPoint +"byfranquia/"+session.franquiaId;
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(endPointGet);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };

    const handleAdd = item => {
        setLoadingForm(true);        
        if (item.termoServicoId === null || item.termoServicoId === 0){
            
            UsePostApi(endPoint,item).then(result=>{            
                if(result.status !== 200 && result.status !== 201)
                {                                     
                    showNotification(result.message.message,'danger');
                    setLoadingForm(false);  
                    return false; 
                } 

                result.data.servico = item.servico;
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList); 

                loadafteradd(result.message);
                return true;                
            }); 
        }
        else{
            UsePutApi(endPoint,item.termoServicoId,item).then(result=>{
                if(result.status !== 200 && result.status !== 201)
                {                                    
                    showNotification(result.message.message,'danger');
                    setLoadingForm(false);  
                    return false; 
                }
                    
                const updateList = list.map(l => (l.termoServicoId === item.termoServicoId ? item : l));
                setListAtualiza(updateList);

                loadafteradd(result.message);
                return true;                 
            });
        }
    }; 
  
    const loadafteradd = (message) =>{
        setLoadingForm(false);  
        handleView(true);
        showNotification(message,'success');
    }    

    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);             
    };
    
    const handleEdit = row => { 
        const endPointGetTermo = endPoint+row.termoServicoId;
      
        UseGetApiSimple(endPointGetTermo,0).then(result=>{         
            if(result.status !== 200)
            {                     
                handleView(false);           
                return false; 
            }  
            setItem(result.data);
            handleView(false);           
            return true;                
        });  

    };

    const columnsProp = [{
        Header: t('label.title'),
        accessor: "titulo"
    },
    {
        Header: t('label.service'),
        accessor: "servico.descricao"
    },
    {
        Header: t('label.status'),
        accessor: "ativoDesc"
    }]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                                        
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>{" "}
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                <TermoServicoForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('information_message.list_of_terms_of_service')}</h4>
                        </CardHeader>
                        <CardBody>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                                {t('button.new')}
                            </Button>                           

                            {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                        />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }                
        </div>
    );
}
